import { Wrench } from 'lucide-react'
import { CATEGORICAL, GRACKLE_COLORS } from '@/lib/theme'

interface MaintenancePageProps {
  message?: string
}

export function MaintenancePage({ message }: MaintenancePageProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" role="main">
      <div className="text-center max-w-md px-6">
        <div className="flex justify-center mb-6">
          <div className="rounded-full p-4" style={{ backgroundColor: CATEGORICAL.pollen.tint }}>
            <Wrench
              className="h-12 w-12"
              style={{ color: GRACKLE_COLORS.prussianBlue }}
              aria-hidden="true"
            />
          </div>
        </div>
        <h1 className="text-2xl font-bold mb-3" style={{ color: GRACKLE_COLORS.prussianBlue }}>
          System Under Maintenance
        </h1>
        <p className="text-muted-foreground text-lg mb-6">
          {message || 'System is under maintenance. Please try again later.'}
        </p>
        <p className="text-sm text-muted-foreground">
          If you need urgent access, please contact your administrator.
        </p>
      </div>
    </div>
  )
}
